import { useRecoilState } from 'recoil';
import { ContextMenus } from '@components/CORE/ContextMenu/ContextMenu';
import { IContextMenuTrigger } from '@types';

import { atom } from 'recoil';

const ToggleCTXID = atom({
	key: '@Ofload/TOGGLE_CTX_ID',
	default: ''
});

export const useContextMenu = () => {
	const [contextMenus, setContextMenus] = useRecoilState(ContextMenus);
	const [toggleCTXID, setToggleCTXID] = useRecoilState(ToggleCTXID);

	const openContext = (props: IContextMenuTrigger) => {
		if (props.event && !props.event.metaKey && !props.event.altKey) {
			const ua = navigator.userAgent;
			const isWindows = /Win/.test(ua);
			if (isWindows && props.event.ctrlKey) return;
			props.event.preventDefault();
			const contextIndex = contextMenus.findIndex((context) => context.id === props.id);
			if (contextIndex < 0) {
				const update = [
					...contextMenus,
					{
						id: props.id,
						data: props.data,
						pos: {
							x: props.event.clientX,
							y: props.event.clientY
						}
					}
				];
				setToggleCTXID(props.id);
				setContextMenus(update);
			} else {
				const updateContexts = contextMenus.map((context) => {
					if (context.id === props.id) {
						return {
							id: props.id,
							data: props.data,
							pos: {
								x: props.event.clientX,
								y: props.event.clientY
							}
						}
					}
					return context;
				});
				setContextMenus(updateContexts);
				setToggleCTXID('');
				setToggleCTXID(props.id);
			}
		}
	}
	const closeContext = (id: string) => {
		const newContexts = contextMenus.filter((context) => context.id !== id);
		setContextMenus(newContexts);
		if (toggleCTXID !== '') setToggleCTXID('');
	}
	const closeAll = () => {
		setContextMenus([]);
		if (toggleCTXID !== '') setToggleCTXID('');
	}

	return {
		openContext, closeContext, closeAll
	};
}
